module.exports = __webpack_public_path__ + "static/media/proj2_img6.64aed79b.jpg";